import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { PersonneState } from '../../../shared/personne.state';
import { MassNotificationModele } from '../../modeles/mass-notifications.modele';
import { DeleteMassNotification, NotificationState } from '../../notification.state';

@Component({
  selector: 'app-place-bubble-notification',
  templateUrl: './place-bubble-notification.component.html',
  standalone: false
})
export class PlaceBubbleComponent implements OnDestroy, OnInit {
  @Select(NotificationState.getMassNotifications)
  notifications$: Observable<MassNotificationModele[]>;
  notificationsSubscription: Subscription;

  notification: MassNotificationModele;

  @Input()
  feature: string;

  @Input()
  visibleOn: 'Web' | 'Mobile' | 'WebAndMobile' = 'WebAndMobile';

  isVisible = false;

  parametresTraduction = {
    titre: '',
    texte: ''
  };

  constructor(private readonly _store: Store) {}

  ngOnInit() {
    this.notificationsSubscription = this.notifications$.subscribe((data: MassNotificationModele[]) => {
      // Pour empêcher de perdre la notification si le component n'est pas affiché assez longtemps
      setTimeout(() => {
        this.notification = data.find(notification => notification.feature === this.feature);
        if (!this.isVisible && this.notification) {
          this.isVisible = true;
          this.parametresTraduction = {
            titre: this.notification ? this.notification.code + '.titre' : '',
            texte: this.notification ? this.notification.code + '.texte' : ''
          };
        }
      }, 1500);
    });
  }

  ngOnDestroy() {
    if (this.notificationsSubscription) {
      this.notificationsSubscription.unsubscribe();
    }
  }

  deleteNotification() {
    if (this.notification && this.shouldBeVisible) {
      this._store.dispatch(new DeleteMassNotification(this.notification.id));
      this.notification = null;
    }
  }

  get shouldBeVisible() {
    return this.visibleOn === 'WebAndMobile' || PersonneState.detectCanal() === this.visibleOn;
  }
}
